import {
  TextField,
  Button,
  Divider,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Chip,
} from "@mui/material";
import ConfermaElimina from "./ConfermaElimina";
import { useFormRCAutoDetails } from "../rcautoContext";
import { useState } from "react";
import styled from "@emotion/styled";
import CustomSelectWithHeaders from "./CustomSelectWithHeaders";
import { CustomSelectMenuProps } from "../../../../constants";
import { DeleteOutline as DeleteIcon } from "@mui/icons-material";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

const Contatti = ({ contatti, legale }) => {
  const { formState, dispatch } = useFormRCAutoDetails();

  const contattiElenco = legale
    ? formState.legale?.contatti
    : formState.cliente?.contatti;

  const hasAgente = legale
    ? formState.legale.contatti?.some(
        (r) => r.agenteCognome !== undefined && r.agenteNome !== undefined
      )
    : formState.cliente.contatti?.some(
        (r) => r.agenteCognome !== undefined && r.agenteNome !== undefined
      );

  const [openDialog, setOpenDialog] = useState(false);
  const [contattoDaEliminare, setContattoDaEliminare] = useState(null);

  const handleAggiungiContatto = () => {
    const currentContatti = legale
      ? formState.legale.contatti
      : formState.cliente.contatti;

    const newRow = {
      idUID: crypto.randomUUID(), // id univoco
      idTipologia: null,
      valore: "",
      predefinito: 0,
      isNew: 1,
    };

    const updated = [...currentContatti, newRow];

    legale
      ? dispatch({
          type: "UPDATE_CONTATTI_LEGALE",
          payload: updated,
        })
      : dispatch({
          type: "UPDATE_CONTATTI_CLIENTE",
          payload: updated,
        });

    const errors = validateContatti(updated);

    const scope = legale ? "Legale" : "Cliente";
    let finalErrors = {
      ...(formState.errors[scope] || {}),
      contatti: errors,
    };

    if (Object.keys(errors).length === 0) {
      delete finalErrors.contatti;
    }

    dispatch({
      type: "set_errors",
      scope,
      payload: finalErrors,
    });
  };

  const handleDeleteContatto = (index) => {
    const currentContatti = legale
      ? formState.legale.contatti
      : formState.cliente.contatti;

    const form = currentContatti.find((_, i) => i === index);

    if (!form) return;

    // Regole di rimozione
    const isOnlyCellulare =
      form.idTipologia === 1 &&
      currentContatti.filter((f) => f.idTipologia === 1).length === 1;
    const isOnlyEmail =
      form.idTipologia === 3 &&
      currentContatti.filter((f) => f.idTipologia === 3).length === 1;

    /*  if (form.predefinito === 1 || isOnlyCellulare || isOnlyEmail) {
      return; // non rimuovere
    } */

    const updated = currentContatti.filter((_, i) => i !== index);

    legale
      ? dispatch({
          type: "UPDATE_CONTATTI_LEGALE",
          payload: updated,
        })
      : dispatch({
          type: "UPDATE_CONTATTI_CLIENTE",
          payload: updated,
        });

    // aggiorna errori
    const scope = legale ? "Legale" : "Cliente";
    const oldErrors = { ...(formState.errors[scope]?.contatti || {}) };

    // rimuovi l'errore della riga cancellata
    delete oldErrors[index];

    // shift degli indici successivi (per non lasciare buchi)
    const newErrors = {};
    Object.keys(oldErrors).forEach((key) => {
      const k = parseInt(key, 10);
      if (k > index) {
        newErrors[k - 1] = oldErrors[k];
      } else if (k < index) {
        newErrors[k] = oldErrors[k];
      }
    });

    let finalErrors = {
      ...(formState.errors[scope] || {}),
      contatti: newErrors,
    };

    if (Object.keys(newErrors).length === 0) {
      delete finalErrors.contatti;
    }

    dispatch({
      type: "set_errors",
      scope,
      payload: finalErrors,
    });
  };

  const handleChangeContatto = (index, field, value) => {
    const currentContatti = legale
      ? formState.legale.contatti
      : formState.cliente.contatti;

    let updated = currentContatti.map((row, i) => {
      if (i === index) {
        let updatedForm = { ...row };
        if (field === "idTipologia") {
          updatedForm.idTipologia = value;
          //reset other fields once the typology is changed
          updatedForm.valore = "";
          updatedForm.predefinito = 0;
        } else if (field === "valore") {
          updatedForm.valore = value;
        } else if (field === "predefinito") {
          updatedForm[field] = value ? 1 : 0;
        }
        return updatedForm;
      }
      return row;
    });

    // Gestione Predefinito/Preventivi
    if (field === "predefinito") {
      const currentRow = currentContatti.find((_, i) => i === index);
      if (currentRow) {
        const targetTipologia = currentRow.idTipologia;

        // Conta quanti predefiniti/preventivi esistono per la stessa tipologia
        const countPredefinito = updated.filter(
          (form) =>
            form.idTipologia === targetTipologia && form.predefinito === 1
        ).length;

        // Se sto togliendo l’unico predefinito/preventivi, impedisco la modifica
        if (field === "predefinito" && countPredefinito === 0 && value === 0) {
          return;
        }

        // Se metto Predefinito/Preventivi = 1, resetto gli altri della stessa tipologia
        if (value === 1) {
          updated = updated.map((row, i) =>
            i !== index && row.idTipologia === targetTipologia
              ? { ...row, [field]: 0 }
              : row
          );
        }
      }
    }

    legale
      ? dispatch({
          type: "UPDATE_CONTATTI_LEGALE",
          payload: updated,
        })
      : dispatch({
          type: "UPDATE_CONTATTI_CLIENTE",
          payload: updated,
        });

    //Gestione errori
    const scope = legale ? "Legale" : "Cliente";
    let newErrors = { ...(formState.errors[scope]?.contatti || {}) };
    console.log(newErrors);
    if (field === "idTipologia") {
      if (!value) {
        newErrors[index] = {
          ...newErrors[index],
          tipologia: "Campo obbligatorio",
        };
      } else {
        // remove the error if exists
        if (newErrors[index]?.tipologia) {
          delete newErrors[index].tipologia;
          if (Object.keys(newErrors[index]).length === 0) {
            delete newErrors[index]; // elimina tutta la riga se vuota
          }
        }
      }
    }

    if (field === "valore") {
      if (!value) {
        newErrors[index] = {
          ...newErrors[index],
          valore: "Campo obbligatorio",
        };
      } else {
        if (newErrors[index]?.valore) {
          delete newErrors[index].valore;
          if (Object.keys(newErrors[index]).length === 0) {
            delete newErrors[index];
          }
        }
      }
    }

    // After cleaning up newErrors…
    let finalErrors = {
      ...(formState.errors[scope] || {}),
      contatti: newErrors,
    };

    // 🚨 If contatti has no errors, remove it
    if (Object.keys(newErrors).length === 0) {
      const { contatti, ...rest } = finalErrors;
      finalErrors = rest;
    }

    dispatch({
      type: "set_errors",
      scope,
      payload: finalErrors,
    });
  };

  const handleConfirmDelete = () => {
    if (contattoDaEliminare !== null) {
      handleDeleteContatto(contattoDaEliminare);
      setOpenDialog(false);
      setContattoDaEliminare(null);
    }
  };

  function canRemoveContact(row) {
    // If Predefinito === 1, the form cannot be removed.
    if (row.isNew !== 1) {
      return false;
    }
    if (row.predefinito === 1) {
      return false;
    }

    return row.predefinito !== 1;
  }

  const validateContatti = (contatti) => {
    const errors = {};
    contatti.forEach((c, index) => {
      const rowErrors = {};
      if (!c.idTipologia) rowErrors.tipologia = "Campo obbligatorio";
      if (!c.valore) rowErrors.valore = "Campo obbligatorio";

      if (Object.keys(rowErrors).length > 0) {
        errors[index] = rowErrors;
      }
    });
    return errors;
  };
  return (
    <Grid item xs={12}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" my={6}>
          Contatti
        </Typography>
        <Box>
          <Button variant="outlined" onClick={handleAggiungiContatto}>
            Aggiungi
          </Button>
        </Box>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Grid item lg={12}>
        <Paper sx={{ mt: "0.5" }}>
          <TableWrapper>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell width="30%">Tipologia</TableCell>
                  <TableCell align="center" width="40%">
                    Valore
                  </TableCell>
                  <TableCell align="center" width="20%">
                    Predefinito
                  </TableCell>
                  {hasAgente && (
                    <TableCell align="center" width="20%">
                      Agente
                    </TableCell>
                  )}
                  <TableCell align="center" />
                </TableRow>
              </TableHead>
              <TableBody>
                {contattiElenco?.map((row, i) => {
                  const groupedOptions = [
                    {
                      label: "Personale",
                      options: contatti
                        .filter((t) => t.Ambito === "Personale")
                        .map((t) => ({
                          value: t.ID,
                          label: t.Tipologia,
                        })),
                    },
                    {
                      label: "Social",
                      options: contatti
                        .filter((t) => t.Ambito === "Social")
                        .map((t) => ({
                          value: t.ID,
                          label: t.Tipologia,
                        })),
                    },
                  ];
                  // Normalize current value
                  let selectValue = row.idTipologia ?? "";

                  // Flatten all values from grouped options
                  const optionValues = groupedOptions.flatMap((group) =>
                    group.options
                      ? group.options.map((opt) => String(opt.value))
                      : [String(group.value)]
                  );

                  if (!optionValues.includes(String(selectValue))) {
                    selectValue = ""; // reset if current value isn't in options
                  }

                  const tipologia = contatti.find(
                    (t) => t.ID === row.idTipologia
                  );

                  return (
                    <TableRow key={i}>
                      <TableCell>
                        <CustomSelectWithHeaders
                          label="Tipologia"
                          name="tipologia"
                          value={selectValue}
                          onChange={(e) =>
                            handleChangeContatto(
                              i,
                              "idTipologia",
                              e.target.value
                            )
                          }
                          error={Boolean(
                            formState.errors[legale ? "Legale" : "Cliente"]
                              ?.contatti?.[i]?.tipologia
                          )}
                          helperText={
                            formState.errors[legale ? "Legale" : "Cliente"]
                              ?.contatti?.[i]?.tipologia
                          }
                          options={groupedOptions}
                          fullWidth
                          MenuProps={CustomSelectMenuProps}
                          required
                        />
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          fullWidth
                          value={row.valore}
                          onChange={(e) =>
                            handleChangeContatto(i, "valore", e.target.value)
                          }
                          error={Boolean(
                            formState.errors[legale ? "Legale" : "Cliente"]
                              ?.contatti?.[i]?.valore
                          )}
                          helperText={
                            formState.errors[legale ? "Legale" : "Cliente"]
                              ?.contatti?.[i]?.valore
                          }
                          type={
                            ["Cellulare", "Telefono", "Fax"].includes(
                              tipologia?.Tipologia
                            )
                              ? "number"
                              : ["Email", "PEC"].includes(tipologia?.Tipologia)
                              ? "email"
                              : "text"
                          }
                          InputProps={
                            tipologia?.Tipologia === "Cellulare"
                              ? {
                                  startAdornment: (
                                    <Chip label="+39" sx={{ mr: 1 }} />
                                  ),
                                }
                              : undefined
                          }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box display="flex" justifyContent="center">
                          {/* Mostra "Predefinito" solo se la tipologia lo prevede */}
                          {tipologia?.Predefinito === 1 && (
                            <Checkbox
                              checked={row.predefinito === 1}
                              onChange={(e) =>
                                handleChangeContatto(
                                  i,
                                  "predefinito",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                          )}
                        </Box>
                      </TableCell>
                      {hasAgente && (
                        <TableCell align="center">
                          <InputLabel
                            sx={{
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          >
                            {row.agenteCognome} {row.agenteNome}
                          </InputLabel>
                        </TableCell>
                      )}
                      <TableCell>
                        {canRemoveContact(row) && (
                          <DeleteIcon
                            color="error"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setContattoDaEliminare(i);
                              setOpenDialog(true);
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableWrapper>
        </Paper>
      </Grid>
      <ConfermaElimina
        open={openDialog}
        setOpen={setOpenDialog}
        onConfirm={handleConfirmDelete}
      />
    </Grid>
  );
};

export default Contatti;
